import React from "react";
import { Select } from "antd";
import { DataGetAction } from "redux/actions/http";
import { useDispatch } from "react-redux";
import { DataGetActionAPI } from "../../redux/actions/http";
const CallFilters = ({
  showAll,
  placeholder,
  marginRight,
  options,
  ItemValue,
  searchId,
  label,
  apiName,
  searchKey,
  isShowingAll,
  className,
  loading = "searching",
  type,
}) => {
  const dispatch = useDispatch();
  const handleChange = (data) => {
    const query = { query: "search", key: searchKey, value: data };
    if (data === "all") {
      query.query = "all";
      if (showAll) {
        return showAll();
      }
    }
    if (type) {
      dispatch(DataGetActionAPI(apiName, type, query, loading));
    } else {
      dispatch(DataGetAction(apiName, query, loading));
    }
  };

  return (
    <Select
      placeholder={placeholder}
      onChange={(e) => {
        handleChange(e);
      }}
      className={className}
      style={{ width: "200px", marginRight: marginRight }}
    >
      {isShowingAll && <Select.Option value="all">All</Select.Option>}
      {options &&
        options.map((Item) => {
          return (
            <Select.Option value={Item[`${ItemValue}`]}>
              {Item[`${label}`]}
            </Select.Option>
          );
        })}
    </Select>
  );
};

export default CallFilters;
